<template>
  <v-container fluid>
    <page-header :use-permission="true" title="공지사항" :use-list="[]" @btnCreate2="toggleWriteAlert" @btnSearch2="retrieveBoard" :custom-button-list="btnList"></page-header>
    <v-row>
      <v-col>
        <real-grid
          ref="dataGrid"
          class="mt-1 mb-5 w-full"
          :options="grid.gridOption"
          :fields="grid.gridFields"
          :columns="grid.gridColumns"
          :height="grid.height"
          :retrieve-api="gridRetrieveApi"
        ></real-grid>
      </v-col>
<!--      <v-data-table-->
<!--        style="width: 100%;"-->
<!--        :headers="headers"-->
<!--        :items="boardData"-->
<!--        :items-per-page="10"-->
<!--        class="test elevation-1 notice-table"-->
<!--        calculate-widths-->
<!--        @click:row="toggleAlert"-->
<!--      >-->
<!--      </v-data-table>-->
    </v-row>
    <notice-dialog :admin="isAdmin" :write="writeType" :context="selectBoard" :show-event="showAlert" @refresh="retrieveBoard"></notice-dialog>
  </v-container>
</template>

<script>
import localStore from '@/utils/localStore'
import { getNoticeCount, getNoticeList, getNoticeDetail } from '@/api/greenCommon/common'
import NoticeDialog from '@/components/monitoring/NoticeDialog'
import PageHeader from '@/layout/components/PageHeader'
import RealGrid from '@/components/grid/Realgrid'
import store from '@/store'

export default {
  name: 'nNotice',
  components: {
    NoticeDialog,
    PageHeader,
    RealGrid
  },
  data() {
    return {
      grid: {
        height: 450,
        gridOption: {
          gridView: {
            edit: {
              appendable: false,
              insertable: false,
              deletable: false
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            rowIndicator: {
              visible: false
            },
            stateBar: {
              visible: false
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridTotal: 0,
        gridFields: [
          {
            fieldName: 'row_num',
            dataType: 'string'
          },
          {
            fieldName: 'title',
            dataType: 'string'
          },
          {
            fieldName: 'insuser',
            dataType: 'string'
          },
          {
            fieldName: 'insdate',
            dataType: 'string'
          },
          {
            fieldName: 'view_cnt',
            dataType: 'string'
          },
          {
            fieldName: 'content',
            dataType: 'string'
          }
        ],
        gridColumns: [
          {
            name: 'row_num',
            fieldName: 'row_num',
            header: {
              text: 'No'
            },
            width: 10,
            editable: false
          },
          {
            name: 'title',
            fieldName: 'title',
            header: {
              text: '제목'
            },
            styleName: 'column-style',
            editable: false
          },
          {
            name: 'insuser',
            fieldName: 'insuser',
            header: {
              text: '작성자'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            width: 30,
            editable: false
          },
          {
            name: 'insdate',
            fieldName: 'insdate',
            header: {
              text: '작성일'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            width: 30,
            editable: false
          },
          {
            name: 'view_cnt',
            fieldName: 'view_cnt',
            header: {
              text: '조회수'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            width: 20,
            editable: false
          }
        ]
      },
      boardData: [],
      headers: [
        {
          text: 'No',
          align: 'start',
          sortable: false,
          value: 'row_num',
          width: 60,
          class: 'text-h6'
        },
        { text: '제목', value: 'title', class: 'text-h6' },
        { text: '작성자', value: 'insuser', width: 120, class: 'text-h6' },
        { text: '작성일', value: 'insdate', width: 140, class: 'text-h6' },
        { text: '조회수', value: 'view_cnt', width: 120, class: 'text-h6' }
      ],
      selectBoard: {
        type: 'notice',
        title: '',
        context: '',
        date: '',
        insuser: ''
      },
      showAlert: false,
      writeType: false,
      isAdmin: false,
      btnList: [
        { id: 'btnSearch2', text: '조회', icon: 'mdi-magnify' },
        {
          id: 'btnCreate2',
          text: '추가',
          icon: 'mdi-file-document-edit'
        }
      ]
    }
  },
  mounted() {
    this.initData()
    // this.retrieveBoard()
  },
  computed: {
    gridRetrieveApi() {
      return getNoticeList
    }
  },
  methods: {
    toggleAlert(any, item) {
      getNoticeDetail(any.row_num).then(res => {
        this.selectBoard.title = res.title
        this.selectBoard.content = res.content
        this.selectBoard.date = res.insdate
        this.selectBoard.pushContent = res.pushContent
        this.selectBoard.pushTitle = res.pushTitle
        this.selectBoard.pushOn = res.pushOn
        this.selectBoard.subType = res.sub_type
        this.selectBoard.rowNum = res.row_num
      })
      this.showAlert = !this.showAlert
      this.writeType = false
    },
    toggleWriteAlert() {
      this.selectBoard = {
        type: 'notice'
      }
      this.showAlert = !this.showAlert
      this.writeType = true
    },
    setClose() {
      this.retrieveBoard()
    },
    initData() {
      if ((this.$store.state.user.grp_auth || '') === 'usergroup001') {
        this.isAdmin = true
      }
      this.$refs.dataGrid.retrieve()
      this.$refs.dataGrid.getGridView().onCellDblClicked = (cgrid, index) => {
        let row = this.$refs.dataGrid.getDataProvider().getJsonRow(index.itemIndex)
        this.toggleAlert(row)
      }
    },
    retrieveBoard() {
      this.$refs.dataGrid.retrieve()
    },
    onClick(cell) {
      // 선택된 행을 데이터셋에 넣어둔다.
      this.selectData = cell
      // 컬럼명이 title인 컬럼만 이동
      if (this.selectData.columnName === 'title') {
        // 선택행의 로우값을 가져온다.
        var getRow = this.$refs.tuiGrid.invoke('getRow', this.selectData.rowKey)
        this.moveDetail(getRow.row_num)
      }
    },
    moveDetail(id) {
      // 상세화면으로 페이지 이동한다.
      this.row_num = id
      this.layer_type = 'NoticeDetail'
      this.component_key++

      this.component_show = true
    },
    createItem() {
      // 상세페이지로 이동합니다.
      this.row_num = 0
      this.layer_type = 'NoticeDetail'
      this.component_key++

      this.component_show = true
    },
    // 페이지이동시 함수
    beforeDestroy: function() {
      // grid 초기화
      this.$refs.tuiGrid.invoke('destroy')
    }
  }
}
</script>

<style lang="less" scoped>
.column-style {
  text-align: right;
}
.box_btn {
  display: block;
  float: right;
  height: 30px;
  margin-right: 5px;
  padding: 5px 10px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
}
.box_btn.orange {
  border: 1px solid #e78800;
  color: #e78800;
}
</style>
